import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M11.894 5.868 3.92 4.25v14l7.75 1.367v.102h.146l.178.031.178-.031h.378v-.141l7.53-1.328V4.253l-8.186 1.615zm-.224 12.86-6.869-1.213V5.321l6.869 1.396v12.01zm7.53-1.213-6.649 1.174V6.631L19.2 5.318v12.197z"
  }), /*#__PURE__*/_jsx("path", {
    d: "m6.11 8.578 4.545.981-.142.658-4.545-.981.142-.658zm0 2.742 4.545.981-.142.658-4.545-.981.142-.658zm4.403 4.38-4.545-.981.142-.658 4.545.981-.142.658zm7.898-7.121.142.658-4.545.981-.142-.658 4.545-.981zm-.001 2.741.142.658-4.545.981-.142-.658 4.545-.981zm-4.403 4.379-.142-.658 4.545-.981.142.658-4.545.981z"
  })]
}), 'AppCatalogue');